/**
 * Rotator
 */

'use strict';

// Mobile: Slider.

;( ( tns ) => {

	const rotator = document.querySelector( '[data-slider="rotator"]' );
	if ( ! rotator ) return;

	const circle        = document.getElementById( 'rotator-circle-mobile' );
	const dots          = document.querySelectorAll( '#rotator-dots-mobile .dot' );
	const illustrations = document.querySelectorAll( '#rotator-illustrations-mobile .illustration' );
	const options       = {
		center    : true,
		container : rotator,
		items     : 1,
		nav       : false,
		speed     : 750,
		responsive: {
			1024: {
				disable: true,
			},
		},
	};

	const sliderInstance = tns( options );

	let previous = 1;
	let forward  = true;

	sliderInstance.events.on( 'transitionStart', event => {

		// Determine direction.

		// Edge case: 5 -> 1.
		if ( 5 === previous && 1 === event.displayIndex ) {
			forward = true;

		// Edge case: 1 -> 5.
		} else if ( 1 === previous && 5 === event.displayIndex ) {
			forward = false;

		// Normal case: displayIndex is greater than previous.
		} else if ( event.displayIndex > previous ) {
			forward = true;

		// Normal case: displayIndex is less than previous.
		} else if ( event.displayIndex < previous ) {
			forward = false;
		}

		previous = event.displayIndex;

		// Illustration in the center of the rotator.
		document.querySelector( '#rotator-illustrations-mobile .illustration.active' ).classList.remove( 'active' );
		illustrations[ event.displayIndex - 1 ].classList.add( 'active' );

		// Angle of radial gradient for the circle.
		circle.style.setProperty( '--angle', `${ 20 * ( event.displayIndex - 1 ) }%` );
		if ( 1 === event.displayIndex && forward ) circle.style.setProperty( '--angle', '100%' );

		// Color of the dots.
		dots.forEach( ( dot, index ) => {

			if ( 0 === event.displayIndex - 1 && forward ) {
				dot.style.setProperty( '--background', 'var( --color-seance )' );
			} else {
				if ( index <= event.displayIndex - 1 ) {
					dot.style.setProperty( '--background', 'var( --color-seance )' );
				} else {
					dot.style.setProperty( '--background', 'var( --color-casper )' );
				}
			}
		});
	});

	sliderInstance.events.on( 'transitionEnd', event => {

		setTimeout( () => {

			if ( 1 === event.displayIndex && forward ) {
				circle.style.setProperty( '--angle', '0%' );
				dots.forEach( dot => dot.style.setProperty( '--background', 'var( --color-casper )' ) );
				dots[0].style.setProperty( '--background', 'var( --color-seance )' );
			}
		}, 250 );
	});

})( tns );

// Desktop: Content opacity and circle.

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'rotatorDesktop', ( $refs ) => ({

		height               : 0,
		stage                : null,
		winHeight            : window.innerHeight,
		win14                : window.innerHeight / 4,
		winMid               : window.innerHeight / 2,
		win34                : window.innerHeight / 4 * 3,
		listItems            : document.querySelectorAll( '[data-list-item]' ),
		listItemIllustrations: document.querySelectorAll( '[data-list-item-illustration]' ),

		init() {
			this.calculateHeight();

			// Set up Konva.

			// Pre-load the illustrations to prevent a flash of white.
			this.listItemIllustrations.forEach( illustration => {
				const img = new Image();
				img.src = illustration.querySelector( 'img' ).getAttribute( 'src' );
			});

			stage = new Konva.Stage({
				container: 'container',
				width    : 464,
				height   : 464,
			});

			// Circle.
			const layerCircle = new Konva.Layer();
			stage.add( layerCircle );

			const circle = new Konva.Circle({
				x          : stage.width() / 2,
				y          : stage.height() / 2,
				radius     : ( stage.width() / 2 ) - 12,
				stroke     : '#a8b1ba',
				strokeWidth: 5,
			});

			layerCircle.add( circle );
			layerCircle.draw();

			// Arc.
			const layerArc = new Konva.Layer();
			stage.add( layerArc );

			const arc = new Konva.Arc({
				x          : stage.width() / 2,
				y          : stage.height() / 2,
				innerRadius: ( stage.width() / 2 ) - 12,
				outerRadius: ( stage.width() / 2 ) - 12,
				angle      : 0,
				rotation   : -90,
				stroke     : '#6A316C',
				strokeWidth: 5,
			});

			layerArc.add( arc );
			layerArc.draw();

			// Dots.
			const layerDotsGray = new Konva.Layer();
			const layerDotsPurple = new Konva.Layer();

			stage.add( layerDotsGray );
			stage.add( layerDotsPurple );

			this.listItems.forEach( ( item, index ) => {

				const grayDot = new Konva.Circle({
					fill       : '#a8b1ba',
					radius     : 18,
					strokeWidth: 12,
					stroke     : '#fff',
				});

				const purpleDot = new Konva.Circle({
					fill       : '#6A316C',
					radius     : 18,
					strokeWidth: 12,
					stroke     : '#fff',
					visible    : false,
				});

				// Place the dots equidistant around a circle, starting at the top.
				const angle = ( ( 360 / this.listItems.length ) * index - 90 );
				grayDot.x( ( stage.width() / 2 ) + ( ( stage.width() / 2 ) - 12 ) * Math.cos( angle * Math.PI / 180 ) );
				grayDot.y( ( stage.height() / 2 ) + ( ( stage.height() / 2 ) - 12 ) * Math.sin( angle * Math.PI / 180 ) );
				purpleDot.x( ( stage.width() / 2 ) + ( ( stage.width() / 2 ) - 12 ) * Math.cos( angle * Math.PI / 180 ) );
				purpleDot.y( ( stage.height() / 2 ) + ( ( stage.height() / 2 ) - 12 ) * Math.sin( angle * Math.PI / 180 ) );

				layerDotsGray.add( grayDot );
				layerDotsPurple.add( purpleDot );

				layerDotsPurple.draw();
			});

			// Scroll event.
			window.addEventListener( 'scroll', () => {

				this.listItems.forEach( ( item, index ) => {
					const rect = item.querySelector( '[data-index]' ).getBoundingClientRect();

					// Draw the arc.
					if ( rect.bottom <= this.win34 && rect.bottom >= this.win14 ) {
						const angle = ( ( 360 / this.listItems.length ) * index ) + ( ( 360 / this.listItems.length ) * ( this.win34 - rect.bottom ) / ( this.win34 - this.win14 ) );
						arc.angle( angle );
						layerArc.batchDraw();
					}

					// Reveal list item's purple dot on scroll up and hide on scroll down.
					if ( rect.top <= this.winMid ) {
						layerDotsPurple.children[ index ].visible( true );
						layerDotsPurple.batchDraw();

						// Unhide the illustration that goes with this list item.
						this.listItemIllustrations[ index ].classList.remove( 'opacity-0' );
					} else {
						layerDotsPurple.children[ index ].visible( false );
						layerDotsPurple.batchDraw();

						// Hide the illustration that goes with this list item,
						// except for the first list item. Never hide the first
						// illustration.
						if ( 0 !== index ) this.listItemIllustrations[ index ].classList.add( 'opacity-0' );
					}
				});
			}, { passive: true });
		},

		calculateHeight() {
			this.height = 0;
			this.listItems.forEach( block => {
				this.height = this.height + block.offsetHeight;
			});
			this.height += ( this.height / this.listItems.length ) / 2; // Add in half the average of one list item as a buffer.

			this.winHeight = window.innerHeight;
			this.win14     = this.winHeight / 4;
			this.winMid    = this.winHeight / 2;
			this.win34     = this.winHeight / 4 * 3;
		},

		blockOpacity( $el ) {
			const top      = $el.getBoundingClientRect().y;
			const position = ( window.innerHeight - top ) / window.innerHeight * 2 * 100;

			if ( 0 <= position && 100 >= position ) {
				$el.style.setProperty( '--opacity', ( position / 100 ) );
			} else if ( 100 < position ) {
				$el.style.setProperty( '--opacity', 1 );
			}
		},
	}) );
});
